const pageQueryParamName = "page";
export default pageQueryParamName;
